export const PostAnnounceSkeleton = () => (
  <div className="mb-10 animate-pulse overflow-hidden rounded-lg bg-background-secondary">
    <div className="w-full p-5 lg:px-16 lg:py-10">
      <div className="mb-4 flex items-center gap-2">
        <div className="size-6 rounded-full bg-skeleton-primary" />
        <div className="h-4 w-14 rounded-sm bg-skeleton-primary" />
        <div className="h-4 w-14 rounded-sm bg-skeleton-primary" />
      </div>
      <div className="mb-2 h-7 rounded-sm bg-skeleton-primary" />
      <div className="mb-5 h-7 w-3/4 rounded-sm bg-skeleton-primary" />
      {Array.from(Array(6).keys()).map(index => (
        <div className="mb-3 h-3 rounded-sm bg-skeleton-primary" key={index} />
      ))}
    </div>
    <hr className="mx-5 px-5 text-text-secondary/30 lg:mx-0" />
    <div className="flex w-full justify-between p-5 lg:px-16 lg:py-10">
      <div className="flex gap-4">
        <div className="flex items-center gap-2">
          <div className="size-6 rounded-full bg-skeleton-primary" />
          <div className="h-4 w-14 rounded-sm bg-skeleton-primary" />
        </div>
        <div className="flex items-center gap-2">
          <div className="size-6 rounded-full bg-skeleton-primary" />
          <div className="h-4 w-14 rounded-sm bg-skeleton-primary" />
        </div>
      </div>
      <div className="">
        <div className="h-6 w-20 rounded-sm bg-skeleton-primary" />
      </div>
    </div>
  </div>
)
